import React, { FunctionComponent } from 'react';

interface RadioProps {
    label: string;
    name: string;
    checked?: boolean;
    defaultValue?: any;
    id: string;
    register: any;
    validation?: any;
    hasError?: boolean;
}

export const Radio: FunctionComponent<RadioProps> = ({
    id,
    name,
    checked = false,
    defaultValue,
    label,
    register,
    validation,
    hasError,
}) => {
    return (
        <div className={`c-radio ${hasError ? 'input--has-error' : ''}`}>
            <input
                className="radio__input"
                id={id}
                {...register(name, validation ? validation : {})}
                defaultChecked={checked}
                defaultValue={defaultValue}
                type="radio"
            />
            <label className="radio__label" htmlFor={id}>
                {label}
            </label>
        </div>
    );
};
